import { render } from "./Home.vue?vue&type=template&id=62b94f94&scoped=true"
const script = {}

import "./Home.vue?vue&type=style&index=0&id=62b94f94&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b94f94"]])

export default __exports__